import { JobId } from '@eigtech/restoration-types'
import { queryOptions, useQueries, useQuery } from '@eigtech/ui-shared-api'
import { DelegateAdminJob, restorationBasePath } from '@eigtech/ui-shared-jobs'
import { get } from '../instance'
import { jobsQueryKeys } from './constants'

const getJob = async (jobId: JobId) => {
  const { job } = await get<{ job: DelegateAdminJob }>(`${restorationBasePath}/job/${jobId}`)
  return job
}

export const getJobQueryOptions = (jobId: JobId) =>
  queryOptions({
    queryKey: jobsQueryKeys.detail(jobId),
    queryFn: () => getJob(jobId),
  })

export const useGetJob = (jobId: JobId) => useQuery(getJobQueryOptions(jobId))

export const useGetJobsDetails = (jobIds: JobId[] | undefined) =>
  useQueries({
    queries: (jobIds ?? []).map(getJobQueryOptions),
  })
